import { render, staticRenderFns } from "./NuevoTraslado.vue?vue&type=template&id=0442eec4&scoped=true"
import script from "./NuevoTraslado.vue?vue&type=script&lang=js"
export * from "./NuevoTraslado.vue?vue&type=script&lang=js"
import style0 from "./NuevoTraslado.vue?vue&type=style&index=0&id=0442eec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0442eec4",
  null
  
)

export default component.exports